export const discountBannerTitle = (discountPercentage: number) =>
  `Limited time offer! Save ${discountPercentage}% off your monthly subscription.`

export const DISCOUNT_BANNER_SUBTITLE = 'No code needed.'
